import React, { useContext, useState, useEffect } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import Typography from "@material-ui/core/Typography";
import SubscriptionsPageConfirm from "./SubscriptionsPageConfirm";
import { getSubscriptions } from "../../../Helpers/api";
import SubscriptionCard from "../../Layout/SubscriptionCard";

const SubscriptionsPage = ({ path, updateShow, setSnack }) => {
  const {
    viewerObj,
    subscriptions,
    subscriptionSubModel,
    ownerOfVODId: publicUserId,
    setSubscriptions,
    setSubscriptionSubModel
  } = useContext(GlobalContext);
  const [currentPlan, setCurrentPlan] = useState(null);
  const [remainingPlans, setRemainingPlans] = useState([]);
  const [confirmPage, setConfirmPage] = useState(false);
  const [newSubscription, setNewSubscription] = useState(null);

  useEffect(() => {
    if (subscriptions?.length) {
      const remaiing_plan_temp = [];
      for (let i of subscriptions) {
        if (i.price_Id == viewerObj.subscription.price_Id) {
          setCurrentPlan({ ...i });
        } else {
          remaiing_plan_temp.push({ ...i });
        }
      }
      setRemainingPlans((prev) => {
        return [...remaiing_plan_temp];
      });
      updateShow(false);
    } else {
      (async () => {
        if (publicUserId) {
          updateShow(true);
          const { data: subscriptionsList } = await getSubscriptions({
            publicUserId,
          });
          const sub_array = [];
          if (subscriptionsList?.subModel && ((subscriptionsList?.subModel == 'tier' && subscriptionsList?.tiers) || (subscriptionsList?.subModel == 'custom' && subscriptionsList?.customSubs))) {
            setSubscriptionSubModel(subscriptionsList?.subModel)
            for (const key in (subscriptionsList?.subModel == 'tier'? subscriptionsList?.tiers : subscriptionsList?.customSubs)) {
              if (
                subscriptionsList?.subModel == 'tier' &&
                subscriptionsList?.tiers.hasOwnProperty(key)
              ) {
                sub_array.push({
                  ...subscriptionsList?.tiers[key],
                  type: key,
                });
              }
              else if (
                subscriptionsList?.subModel == 'custom' &&
                subscriptionsList?.customSubs.hasOwnProperty(key)
              ) {
                sub_array.push({
                  ...subscriptionsList?.customSubs[key],
                  product_Id:key
                });
              }
            }
          }
          sub_array.length && setSubscriptions([...sub_array]);
          updateShow(false);
        }
      })();
    }
  }, [viewerObj, subscriptions]);

  const CardHeading = ({ text }) => (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Typography variant="h5" className="subscription-heading">
        {text}
      </Typography>
    </div>
  );

  return confirmPage ? (
    <SubscriptionsPageConfirm
      onClickCancel={() => setConfirmPage(false)}
      updateShow={(val) => {
        updateShow(val);
      }}
      newSubscription={newSubscription}
      currentSubcription={currentPlan}
      updateConfirm={(val) => setConfirmPage(val)}
      setSnack={setSnack}
      subscriptionSubModel
    />
  ) : (
    <div style={{}}>
      <CardHeading text={"Current Subscription"} />
      {currentPlan && (
        <SubscriptionCard
          {...currentPlan}
          buttonText={
            viewerObj?.subscription?.scheduling == "cancelation"
              ? "Cancel schedule removal"
              : "Remove"
          }
          cardStyle={{ width: "100%", marginTop: "20px" }}
          buttonStyle={{ width: "max-content", alignSelf: "flex-end" }}
          onClick={() => {
            setNewSubscription(null);
            setConfirmPage(true);
          }}
          glow
        />
      )}
      <CardHeading text={"Available Subscription"} />
      {remainingPlans.map((val, index) => (
        <SubscriptionCard
          key={index}
          {...val}
          buttonText={
            viewerObj?.subscription?.price_Id == val?.price_Id
              ? `Cancel ${viewerObj?.subscription?.scheduling}`
              : "Update"
          }
          cardStyle={{ width: "100%", marginTop: "20px" }}
          buttonStyle={{ width: "max-content", alignSelf: "flex-end" }}
          onClick={() => {
            const { price, period } = val;
            setNewSubscription({
              price,
              period,
              ...val,
            });
            setConfirmPage(true);
          }}
          glow
        />
      ))}
    </div>
  );
};

export default SubscriptionsPage;
